import PlaceStatusModel    from '@models/map/PlaceStatusModel';
import ProjectModel        from '@models/map/ProjectModel';
import PlaceTypeModel      from '@models/map/PlaceTypeModel';
import doc                 from '@widesk-core/decorators/doc';
import model               from '@widesk-core/decorators/model';
import MapServiceModel     from '@/models/MapServiceModel';
import TimestampAble       from '@widesk-core/models/traits/TimestampAble';
import Blamable            from '@/models/traits/Blamable';
import WithProjectPagePath from '@/models/traits/WithProjectPagePath';
import { RenderNameProps } from '@widesk-ui/mixins/ApiModelRenderName';
import fileStore           from '@/stores/fileStore';

@model.urnResource('place')
@doc.path('/places/{?id}')
export default class PlaceModel extends Blamable(TimestampAble(WithProjectPagePath(MapServiceModel))) {
	private declare _tsFilters: {
		'createdAt': string;
		'exists[mapPlaces]': boolean;
		'exists[mapVersionPlaces]': boolean;
		'mapPlaces': id;
		'mapVersionPlaces': id;
		'placeFields': id;
		'placeStatus': id;
		'placeType': id;
		'project': id;
		'project.owner.accountUrn': string;
		'updatedAt': string | Date | Dayjs;
	};

	private declare _tsSorts: {
		'createdAt': string;
		'id': string;
		'label': string;
		'updatedAt': string;
	};

	@doc.string declare label: string;
	@doc.string declare location: string;
	@doc.model(PlaceStatusModel) declare placeStatus: PlaceStatusModel;
	@doc.model(PlaceTypeModel) declare placeType: PlaceTypeModel;
	@doc.model(ProjectModel) declare project: ProjectModel;
	@doc.string declare reference: Map_PlaceReference;

	public renderName(props?: RenderNameProps<this> & RenderNameImageProps) {
		return super.renderName(props);
	}

	public async fetchImageSrc(force = false) {
		await fileStore.fetchForModel(this, { force });
		const image = fileStore.getFilesForModel(this).find(file => file.typeSource?.type?.reference === 'place_image');

		return image?.downloadPath || '';
	}
}